import React from 'react'

function AAD_program_details() {
  return (
    <div>
    {/* ------------------Mobile View--------------- */}
    <div className='d-sm-block d-md-none'>
      <div className='container'>
        <div className='row'>
            <div className='col-md-12 detail_1stcomp_img'>
                <div className='Mobile_view_Program_details_1stcomp_text text-center'>
                    <h1 className='display-6'>Mastering Android Wonders!</h1>
                    <p className='py-2'>Dive into the world of Android programming with our dynamic course. Unlock the secrets of app development. Enrol now for a bright future in tech innovation!</p>
                </div>
                <div className='mt-4 Mobile_view_Program_details_1stcomp_text text-center'>
                    <h1 className='display-4'>Overview</h1>
                    <p className='py-2'>Embark on a dynamic journey into Android development with our comprehensive Training Internship. Delve into live projects guided by industry experts, covering the entire Android development spectrum. From foundational concepts to advanced Flutter applications, gain hands-on experience in UI/UX, form creation, and navigation. Elevate your skills through a robust curriculum, earning three major certified certificates upon completion. Propel your career with internship and placement opportunities, ensuring you're equipped to thrive in the evolving world of Android development. Let's start your transformative learning experience!</p>
                </div>
            </div>
            <div className='col-md-12'>
                <div>
                <div className=' Details_container shadow-lg px-3 py-4'>
                <h1 className='mobile_view_Details_text text-center  pb-2 border-bottom'>Android App Development</h1>
                  <div className='mobile_view_Details_text'>
                    <ul className='pt-2'>
                      <li>Live conversations with industry professionals</li>
                      <li className='py-3'>Project support and Guidance</li>
                      <li>Access to Specialized Course Materials</li>
                      <li className='py-3'>25+ Hours of Learning</li>
                      <li>Certificates from reputable MNC's around the world</li>
                    </ul>
                  </div>
                  <div className='text-center'>
                  {/* <a href=''><button className="text-white shadow-sm mt-3 fs-5 px-5 pt-1 pb-2 Pr_details_button">Enroll Now</button></a> */}
                  </div>
                </div>
                </div>
            </div>
        </div>
      </div>
    </div>
    
    {/* -------------------------Desktop view----------------------- */}
    <div className='d-none d-md-block'>
      <div className='container'>
        <div className='row'>
            <div className='col-md-8 detail_1stcomp_img'>
                <div className='pt-3 Program_details_1stcomp_text'>
                    <h1 className='display-6'>Mastering Android Wonders!</h1>
                    <p className='py-4'>Dive into the world of Android programming with our dynamic course. Unlock the secrets of app development. Enrol now for a bright future in tech innovation!</p>
                </div>
                <div className='mt-3 Program_details_1stcomp_text'>
                    <h1 className='display-3'>Overview</h1>
                    <p className='py-4'>Embark on a dynamic journey into Android development with our comprehensive Training Internship. Delve into live projects guided by industry experts, covering the entire Android development spectrum. From foundational concepts to advanced Flutter applications, gain hands-on experience in UI/UX, form creation, and navigation. Elevate your skills through a robust curriculum, earning three major certified certificates upon completion. Propel your career with internship and placement opportunities, ensuring you're equipped to thrive in the evolving world of Android development. Let's start your transformative learning experience!</p>
                </div>
            </div>
            <div className='col-md-4'>
                <div>
                <div className=' Details_container shadow-lg px-3 pt-4 pb-5'>
                <h1 className='Details_text text-center  pb-4 pt-3 border-bottom'>Android App Development</h1>
                  <div className='Details_text '>
                    <ul className='pt-4'>
                      <li>Live conversations with industry professionals</li>
                      <li className='py-3'>Project support and Guidance</li>
                      <li>Access to Specialized Course Materials</li>
                      <li className='py-3'>25+ Hours of Learning</li>
                      <li>Certificates from reputable MNC's around the world</li>
                    </ul>
                  </div>
                  <div className='text-center'>
                  {/* <a href=''><button className="text-white shadow-sm mt-3 fs-5 px-5 pt-1 pb-2 Pr_details_button">Enroll Now</button></a> */}
                  </div>
                </div>
                </div>
            </div>
        </div>
      </div>
    </div>
    </div>
  )
}

export default AAD_program_details
